import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { TypeRampV2 } from "../../typography";
import { chipTheme } from "./chipTheme";
export var ChipLabelStyled = styled(TypeRampV2)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding: 0 6px 0 4px;\n    letter-spacing: 0.2px;\n    word-break: break-all;\n\n    // Lodestar and Ursa Chips both use the same font styles\n    font-size: var(--smar--sds--chip--font-size, ", ");\n    padding-right: var(\n        --smar--sds--chip--label--padding-right,\n        ", "\n    );\n    padding-left: var(\n        --smar--sds--chip--label--padding-left,\n        ", "\n    );\n    font-weight: var(--smar--sds--chip--label--weight, ", ");\n    line-height: var(--smar--sds--chip--label--line-height, ", ");\n"])), function (_ref) {
  var fontSize = _ref.fontSize;
  return fontSize;
}, function (_ref2) {
  var themeMode = _ref2.themeMode,
    chipSize = _ref2.chipSize;
  return chipTheme.padding.right[chipSize](themeMode);
}, function (_ref3) {
  var themeMode = _ref3.themeMode,
    chipSize = _ref3.chipSize;
  return chipTheme.padding.left[chipSize](themeMode);
}, function (_ref4) {
  var fontWeight = _ref4.fontWeight;
  return fontWeight;
}, function (_ref5) {
  var lineHeight = _ref5.lineHeight;
  return lineHeight;
});
//# sourceMappingURL=ChipLabelStyled.js.map